/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs */

const en_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock levels synced across Amazon, Shopify and WooCommerce, oversells stopped.`)
};

const ar_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستويات المخزون متزامنة عبر أمازون وShopify وWooCommerce، وتوقف البيع الزائد.`)
};

const bn_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমাজন, Shopify আর WooCommerce-এ স্টক সিঙ্ক, অতিরিক্ত বিক্রি বন্ধ।`)
};

const de_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestände über Amazon, Shopify und WooCommerce synchronisiert, Überverkäufe gestoppt.`)
};

const es_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveles de stock sincronizados entre Amazon, Shopify y WooCommerce, sin sobreventas.`)
};

const fr_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveaux de stock synchronisés entre Amazon, Shopify et WooCommerce, surventes stoppées.`)
};

const pt_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Níveis de stock sincronizados entre Amazon, Shopify e WooCommerce, sem sobrevendas.`)
};

const zh_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亚马逊、Shopify 和 WooCommerce 库存同步，杜绝超卖。`)
};

const tr_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoklar Amazon, Shopify ve WooCommerce arası senkron, fazla satış durdu.`)
};

const ru_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остатки синхронизированы между Amazon, Shopify и WooCommerce, перепродажи остановлены.`)
};

const pl_svc_ecommerce_amazon_tools_sync_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stany magazynowe zsynchronizowane między Amazon, Shopify i WooCommerce, koniec z nad-sprzedażą.`)
};

/**
* | output |
* | --- |
* | "Stock levels synced across Amazon, Shopify and WooCommerce, oversells stopped." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_sync_desc4 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Sync_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_sync_desc4(inputs)
	return en_svc_ecommerce_amazon_tools_sync_desc4(inputs)
});
export { svc_ecommerce_amazon_tools_sync_desc4 as "svc_ecommerce-amazon-tools_SYNC_desc" }